<div class="md:mx-auto w-full md:max-w-md px-5">
  @if (!orderStatus) {
    <h1 class="font-accent font-bold mt-5 mb-3 md:mt-6 text-md md:text-center">
      {{ 'validate-shared-order.subtitle' | translate }}
    </h1>
  }
  @if (orderStatus === orderStatusValues.Payment) {
    <h1 class="font-accent font-bold mt-5 mb-3 md:mt-6 text-md md:text-center">
      {{ 'validate-shared-order.subtitle-payment-in-progress' | translate }}
    </h1>
  }
  @if (orderStatus === orderStatusValues.Cancelled) {
    <h1 class="font-accent font-bold mt-5 mb-3 md:mt-6 text-md md:text-center">
      {{ 'validate-shared-order.subtitle-payment-cancelled' | translate }}
    </h1>
  }
  @if (reconstructedBasketSubCarts$ | async; as confirmedUsers) {
    <div class="mb-80">
      <ul>
        @for (confirmedUser of confirmedUsers; track confirmedUser) {
          <li class="mb-10">
            <p
              class="py-2 px-1 bg-neutral-800 text-white text-sm text-center mt-4 font-base font-bold"
            >
              {{ confirmedUser.user.firstname }}
              @if (!confirmedUser.user.firstname) {
                {{ 'basket.anonymous' | translate }}
              }
              @if ((userId$ | async) === confirmedUser.user.id) {
                <span>({{ 'basket.you' | translate }})</span>
              }
            </p>
            @if (confirmedUser.isConfirmed) {
              <p class="flex justify-between pt-4 font-bold font-base text-base">
                <span>
                  {{ confirmedUser.items }}
                  @if (confirmedUser.items === 1) {
                    <span>{{ 'validate-shared-order.product' | translate }}</span>
                  }
                  @if (confirmedUser.items > 1) {
                    <span>{{ 'validate-shared-order.products' | translate }}</span>
                  }
                </span>
                <span>
                  <app-price-atom
                    [amount]="confirmedUser.total"
                    [format]="true"
                  ></app-price-atom>
                </span>
              </p>
            }
            @if (!confirmedUser.isConfirmed) {
              <p class="pt-4 font-bold font-base text-base">
                {{ 'validate-shared-order.waiting-validation' | translate }}
              </p>
            }
          </li>
        }
      </ul>
      @if (total$ | async; as total) {
        <p class="flex justify-between pt-6 font-bold font-base text-base">
          <span>Total: </span>
          <span
            ><app-price-atom
              [format]="true"
              [amount]="total"
              [bold]="true"
            ></app-price-atom
          ></span>
        </p>
      }
      @if (!orderStatus) {
        <p class="pt-6 font-base text-base">
          {{ 'validate-shared-order.information' | translate }}
        </p>
      }
      @if (orderStatus === orderStatusValues.Payment) {
        <p class="pt-6 font-base text-base">
          {{ 'validate-shared-order.information-2' | translate }}
        </p>
      }
      @if (orderStatus === orderStatusValues.Cancelled) {
        <div class="mt-6">
          <app-button-atom
            size="M"
            [label]="'validate-shared-order.home-button' | translate"
            color="primary"
            (click)="goHome()"
            type="primary"
            [full]="true"
          ></app-button-atom>
        </div>
      }
    </div>
  }
</div>
